module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ef-Fb-Gb.d37b52ea.png";